// import React, { useEffect, useState } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { fetchProfile, updateProfile } from '../hooks/Profile'
// import { useNavigate } from 'react-router-dom';
// import CustomForm from '../Components/CustomForm/CustomForm';

// function Profile() {
//   const dispatch = useDispatch();
//   const navigate=useNavigate()
  // const { list: profile } = useSelector((state) => state.Profile)
//   const [name, setName] = useState('') 
//    const [email, setEmail] = useState('')
//     const [phone, setPhone] = useState('')
//   const [national_number, setNational_number] = useState(""); 
//     const [username, setUsername] = useState('')
//   const [loading, setLoading] = useState(false)

//   useEffect(() => {
//     dispatch(fetchProfile())
//   }, [dispatch])
//     useEffect(() => {
  
  
//       setName(profile?.name)
//       setEmail(profile?.email)
//       setPhone(profile?.phone)
//     setUsername(profile?.username)
//     setNational_number(profile?.national_number)
  
//     }, [])
//       const infoData = [
//     {
//       id: 0,
//       title: "معلومات أساسية",
//       inputs: [
      
//     { id: 0, title: "name", value: name, onChanegFunction: (e) => setName(e.target.value), grid: 6 },
//     { id: 1, title: "userName", value: username, onChanegFunction: (e) => setUsername(e.target.value), grid: 6 },
//     { id: 2, title: "email", value: email, onChanegFunction: (e) => setEmail(e.target.value), grid: 6 },
//     { id: 3, title: "phone", value: phone, onChanegFunction: (e) => setPhone(e.target.value), grid: 6 },
//     { id: 4, title: "national_number", value: national_number, onChanegFunction: (e) => setNational_number(e.target.value), grid: 6 },

//       ],
//     },
//   ];

//     const handleSubmit = () => {
//       const dataToSend = { name: name, email: email, phone: phone, identity_number: national_number,username:username}
      
//        setLoading(true)
  
//       dispatch(updateProfile(dataToSend))
//         .unwrap()
//         .then(() => {
//           setLoading(false)
//           dispatch(fetchProfile())
//           alert("edidedsuccessfully")
  
//         })
//         .catch((err) => {
//           setLoading(false)
  
//         });
//     }
//   return (
//     <div className='px-4'>

//       <div className='mx-4 filter_container profile_container py-3 px-3'>
//         <div className='pb-4'>
//         <CustomForm
//           inputs={infoData}
//           btnText={"حفظ"}
//           handleSubmit={handleSubmit}
//           loading={loading}

//         />
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Profile


import React, { useEffect } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import { addRestaurant } from '../hooks/resturant'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { fetchProfile } from '../hooks/Profile'

function Profile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { list: profile } = useSelector((state) => state.Profile)
console.log(profile);

  useEffect(() => {
  dispatch(fetchProfile())

  }, [])
      const infoData = [
    {
      id: 0,
      title: "معلومات أساسية",
      inputs: [
        { id: "name", title: "الاسم", type: "text" },
        { id: "military_number", title: "الرقم العسكري", type: "text" },
                { id: "username", title: "اسم المستخدم", type: "text" },
        { id: "rank", title: "الرتبة", type: "text" },
        { id: "workplace", title: "جهة العمل", type: "text" },
        { id: "workplace", title: "اسم المطعم", type: "text",value:profile?.restaurant?.name,disable:true },

      ],
    },
  ];

  const handleSubmit = (formData) => {
    
    // formData will usually be an object like { name: "Restaurant Name" }
    dispatch(addRestaurant(formData))
      .unwrap() // Allows us to use .then() / .catch() on the thunk result
      .then(() => {
        alert("تم إضافة المطعم بنجاح");
        navigate('/dashboard/resturants'); // Redirect to list page
      })
      .catch((err) => {
        // Error is already handled in Redux, but you can do specific UI logic here
        console.error("Failed to save:", err);
      });
  };
  return (
    <div>
        <AuthNavbar/>
          <Container>
                    <CustomHeader
          title={"تعديل البيانات الشخصية"}
          subtitle={""}
          downloadData={false}
        />
        <CustomForm
formStructure={infoData}
image={false}
onSubmit={handleSubmit}
initialData={profile}
        />
            </Container>
            </div>
  )
}

export default Profile
